import { getHostingAppId, getNativeResourceGroupId } from '@feedyou/utils'

import { confirm } from '../../../../../lib/bootbox'

export async function confirmArchivation(botId: string): Promise<boolean> {
  return confirm({
    title: '⚠️ Archive bot',
    message: `Are you sure you want to archive bot <strong>${botId}</strong>? It will always be possible to restore it, including the entire communication structure and NLP models.<br /><br /><strong>The hosting with user data and version history will be deleted permanently in 30 days.</strong>`,
    buttons: {
      confirm: { label: 'Archive bot', className: 'btn-negative' },
      cancel: { label: 'Cancel' }
    }
  })
}

export function confirmArchivationDespiteNonNativeHostingId(
  botId: string,
  botApiUrl: string
): Promise<boolean> {
  const botHostingId = getHostingAppId(botApiUrl)
  const nativeBotHostingId = getNativeResourceGroupId(botId, window.REALTIME_NAMESPACE || '')
  return confirm({
    title: `❌ Hosting mismatch with API URL`,
    message: `Your bot’s hosting ID ${nativeBotHostingId} does not match with the API URL defined in the bot settings JSON (${botApiUrl}). 
							It might happen when you copy the API URL from another bot. 
							Hosting <strong>${botHostingId}</strong> will be archived, and deleted after 30 days.<br /><br />
							Do you really want to continue? 
							If you are not sure contact <a target="_blank" rel="noopener noreferrer" href="https://feedyou.atlassian.net/servicedesk/customer/portals">our support</a>.`,
    buttons: {
      confirm: {
        label: 'Archive bot anyway',
        className: 'btn-negative'
      },
      cancel: {
        label: 'Close'
      }
    }
  })
}
